import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=60c1da82&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1da82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c1da82')) {
      api.createRecord('60c1da82', component.options)
    } else {
      api.reload('60c1da82', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=60c1da82&scoped=true&", function () {
      api.rerender('60c1da82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PZ0nrcyyN7Nc/JS/comp/Voucher-Unit.vue"
export default component.exports